// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Keep "Witaj w aplikacji AgemaHR" on one line only on non-mobile */
@media only screen and (min-width: 821px) {
    .login-page .login-figma-hero {
        display: none;
    }

    .login-page .login-figma-hero {
        text-align: center;
    }

    .login-page .login-welcome,
    .login-page .login-brand {
        display: inline;
        white-space: nowrap;
    }

    .login-page .login-welcome {
        margin-right: 0.35em;
    }
}

@media only screen and (max-width: 1024px) {
    body.login-route .home-header {
        display: none;
    }

    body.login-route {
        background: #ffffff;
    }

    .login-page {
        background: #ffffff;
        padding: 0;
    }

    .login-page br {
        display: none;
    }

    .login-page .home-hero {
        width: 100%;
        min-height: 100vh;
        align-items: flex-start;
        justify-content: center;
        padding: 44px 24px 48px;
        box-sizing: border-box;
    }

    .login-page .padding-body-2 {
        width: 100%;
        max-width: 560px;
        margin: 0 auto;
        padding: 0;
    }

    .login-page .padding-body-2 > .MuiGrid-item {
        width: 100%;
        max-width: 100%;
        flex-basis: 100%;
    }

    .login-page .login-paper {
        width: 100%;
        max-width: none;
        margin: 0;
        border: 0 !important;
        border-radius: 0 !important;
        box-shadow: none !important;
        background: #ffffff !important;
    }

    .login-page form {
        background: transparent;
        color: #187eb4;
        padding: 36px 28px 56px;
    }

    .login-page .login-figma-hero {
        text-align: center;
        margin-bottom: 34px;
    }

    .login-page .login-figma-kicker {
        text-align: left;
        color: #3194de;
        font-weight: 700;
        letter-spacing: 0.01em;
        font-size: 22px;
        margin-bottom: 40px;
    }

    .login-page .login-welcome {
        color: #1b80b5;
        font-size: 34px;
        font-weight: 500;
        line-height: 1.1;
        white-space: nowrap;
    }

    .login-page .login-brand {
        color: #1f1f1f;
        font-size: 56px;
        font-weight: 500;
        line-height: 1.06;
    }

    .login-page .login-brand span {
        color: #197caf;
        font-weight: 700;
    }

    .login-page .login-avatar {
        width: 140px;
        margin: 88px auto 24px;
        position: relative;
        height: 128px;
    }

    .login-page .login-avatar-head {
        width: 50px;
        height: 50px;
        border: 3px solid #1b80b5;
        border-radius: 50%;
        margin: 0 auto;
        background: transparent;
    }

    .login-page .login-avatar-body {
        width: 95px;
        height: 74px;
        border: 3px solid #1b80b5;
        border-radius: 44px 44px 15px 15px;
        border-top: 0;
        margin: -2px auto 0;
        background: transparent;
    }

    .login-page .login-title {
        text-align: center;
        font-size: 30px !important;
        font-weight: 700 !important;
        line-height: 1.15;
        color: #1b80b5;
        margin: 0 0 24px !important;
        white-space: nowrap;
    }

    .login-page .validation-error {
        text-align: center;
        margin-bottom: 8px;
    }

    .login-page .MuiFormControl-root {
        margin: 0 0 16px !important;
        background: #d7e3ec !important;
        border-radius: 8px;
        overflow: hidden;
    }

    .login-page .MuiOutlinedInput-root {
        border-radius: 8px;
        background: #d7e3ec !important;
    }

    .login-page .MuiOutlinedInput-notchedOutline {
        border: 0 !important;
    }

    .login-page .MuiInputBase-input {
        color: #177eb4 !important;
        font-size: 20px;
        line-height: 1.2;
        padding: 12px 14px;
        font-weight: 500;
    }

    .login-page form label {
        color: #177eb4 !important;
        font-size: 18px;
        transform: translate(14px, 11px) scale(1);
        font-weight: 500;
    }

    .login-page .MuiInputLabel-shrink {
        opacity: 0;
    }

    .login-page .login-actions {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        margin-top: 12px;
    }

    .login-page .login-forgot-wrap {
        flex: 1 1;
        display: flex;
        align-items: center;
    }

    .login-page .forgot-password {
        display: inline-block;
        color: #187eb4;
        font-size: 15px;
        text-decoration: none;
        line-height: 1.2;
        transform: translateY(-5px);
    }

    .login-page .forgot-password:hover {
        text-decoration: underline;
    }

    .login-page .buttonFilled {
        margin-top: 0 !important;
        width: 120px !important;
        min-width: 120px;
        min-height: 38px;
        border-radius: 10px !important;
        background-color: #1ea8eb !important;
        box-shadow: none !important;
        text-transform: uppercase;
        font-size: 14px !important;
        font-weight: 700 !important;
        letter-spacing: 0.02em;
        padding: 0 14px !important;
    }

    .login-page .buttonFilled:hover {
        background-color: #1799d8 !important;
    }

    .login-page .buttonFilled span {
        color: #fff !important;
    }
}

@media only screen and (max-width: 820px) {
    .login-page .home-hero {
        padding: 28px 16px 34px;
    }

    .login-page form {
        padding: 28px 18px 40px;
    }

    .login-page .login-figma-kicker {
        font-size: 16px;
        margin-bottom: 24px;
    }

    .login-page .login-welcome {
        font-size: 20px;
    }

    .login-page .login-brand {
        font-size: 30px;
    }

    .login-page .login-avatar {
        width: 130px;
        height: 120px;
        margin: 74px auto 26px;
    }

    .login-page .login-avatar-head {
        width: 48px;
        height: 48px;
        border-width: 3px;
    }

    .login-page .login-avatar-body {
        width: 100px;
        height: 72px;
        border-width: 3px;
        border-radius: 42px 42px 16px 16px;
    }

    .login-page .login-title {
        font-size: 22px !important;
        margin-bottom: 20px !important;
    }

    .login-page .login-actions {
        margin-top: 10px;
    }

    .login-page .MuiInputBase-input {
        font-size: 13px;
        padding: 10px 12px;
    }

    .login-page form label {
        font-size: 13px;
        transform: translate(12px, 9px) scale(1);
    }

    .login-page .forgot-password {
        font-size: 12px;
        transform: translateY(-4px);
    }

    .login-page .buttonFilled {
        min-height: 34px;
        width: 98px !important;
        min-width: 98px;
        font-size: 12px !important;
    }
}

@media (prefers-color-scheme: dark) and (max-width: 1024px) {
    body.login-route,
    .login-page,
    .login-page .home-hero,
    .login-page .padding-body-2 {
        background: #3a3a3a !important;
    }

    .login-page .login-paper {
        background: #121212 !important;
    }

    .login-page .MuiFormControl-root,
    .login-page .MuiOutlinedInput-root,
    .login-page .MuiInputBase-root {
        background: #1a2733 !important;
    }

    .login-page .MuiInputBase-input,
    .login-page textarea.MuiInputBase-input {
        color: #ffffff !important;
        -webkit-text-fill-color: #ffffff !important;
    }

    .login-page form label,
    .login-page .MuiFormLabel-root,
    .login-page .MuiInputLabel-root {
        color: #ffffff !important;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/login/loginComponent.css"],"names":[],"mappings":"AAAA,oEAAoE;AACpE;IACI;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;;QAEI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,UAAU;IACd;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,iBAAiB;QACjB,uBAAuB;QACvB,uBAAuB;QACvB,uBAAuB;QACvB,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,cAAc;QACd,UAAU;IACd;;IAEA;QACI,WAAW;QACX,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,SAAS;QACT,oBAAoB;QACpB,2BAA2B;QAC3B,2BAA2B;QAC3B,8BAA8B;IAClC;;IAEA;QACI,uBAAuB;QACvB,cAAc;QACd,uBAAuB;IAC3B;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,cAAc;QACd,gBAAgB;QAChB,sBAAsB;QACtB,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,sBAAsB;QACtB,kBAAkB;QAClB,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,yBAAyB;QACzB,kBAAkB;QAClB,cAAc;QACd,uBAAuB;IAC3B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,yBAAyB;QACzB,kCAAkC;QAClC,aAAa;QACb,mBAAmB;QACnB,uBAAuB;IAC3B;;IAEA;QACI,kBAAkB;QAClB,0BAA0B;QAC1B,2BAA2B;QAC3B,iBAAiB;QACjB,cAAc;QACd,2BAA2B;QAC3B,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,2BAA2B;QAC3B,8BAA8B;QAC9B,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,8BAA8B;IAClC;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,yBAAyB;QACzB,eAAe;QACf,gBAAgB;QAChB,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;QACzB,eAAe;QACf,yCAAyC;QACzC,gBAAgB;IACpB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,SAAO;QACP,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,qBAAqB;QACrB,cAAc;QACd,eAAe;QACf,qBAAqB;QACrB,gBAAgB;QAChB,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,wBAAwB;QACxB,uBAAuB;QACvB,gBAAgB;QAChB,gBAAgB;QAChB,8BAA8B;QAC9B,oCAAoC;QACpC,2BAA2B;QAC3B,yBAAyB;QACzB,0BAA0B;QAC1B,2BAA2B;QAC3B,sBAAsB;QACtB,0BAA0B;IAC9B;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,YAAY;QACZ,iBAAiB;QACjB,kCAAkC;IACtC;;IAEA;QACI,0BAA0B;QAC1B,8BAA8B;IAClC;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,wCAAwC;IAC5C;;IAEA;QACI,eAAe;QACf,2BAA2B;IAC/B;;IAEA;QACI,gBAAgB;QAChB,sBAAsB;QACtB,eAAe;QACf,0BAA0B;IAC9B;AACJ;;AAEA;IACI;;;;QAII,8BAA8B;IAClC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;;;QAGI,8BAA8B;IAClC;;IAEA;;QAEI,yBAAyB;QACzB,2CAA2C;IAC/C;;IAEA;;;QAGI,yBAAyB;IAC7B;AACJ","sourcesContent":["/* Keep \"Witaj w aplikacji AgemaHR\" on one line only on non-mobile */\r\n@media only screen and (min-width: 821px) {\r\n    .login-page .login-figma-hero {\r\n        display: none;\r\n    }\r\n\r\n    .login-page .login-figma-hero {\r\n        text-align: center;\r\n    }\r\n\r\n    .login-page .login-welcome,\r\n    .login-page .login-brand {\r\n        display: inline;\r\n        white-space: nowrap;\r\n    }\r\n\r\n    .login-page .login-welcome {\r\n        margin-right: 0.35em;\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 1024px) {\r\n    body.login-route .home-header {\r\n        display: none;\r\n    }\r\n\r\n    body.login-route {\r\n        background: #ffffff;\r\n    }\r\n\r\n    .login-page {\r\n        background: #ffffff;\r\n        padding: 0;\r\n    }\r\n\r\n    .login-page br {\r\n        display: none;\r\n    }\r\n\r\n    .login-page .home-hero {\r\n        width: 100%;\r\n        min-height: 100vh;\r\n        align-items: flex-start;\r\n        justify-content: center;\r\n        padding: 44px 24px 48px;\r\n        box-sizing: border-box;\r\n    }\r\n\r\n    .login-page .padding-body-2 {\r\n        width: 100%;\r\n        max-width: 560px;\r\n        margin: 0 auto;\r\n        padding: 0;\r\n    }\r\n\r\n    .login-page .padding-body-2 > .MuiGrid-item {\r\n        width: 100%;\r\n        max-width: 100%;\r\n        flex-basis: 100%;\r\n    }\r\n\r\n    .login-page .login-paper {\r\n        width: 100%;\r\n        max-width: none;\r\n        margin: 0;\r\n        border: 0 !important;\r\n        border-radius: 0 !important;\r\n        box-shadow: none !important;\r\n        background: #ffffff !important;\r\n    }\r\n\r\n    .login-page form {\r\n        background: transparent;\r\n        color: #187eb4;\r\n        padding: 36px 28px 56px;\r\n    }\r\n\r\n    .login-page .login-figma-hero {\r\n        text-align: center;\r\n        margin-bottom: 34px;\r\n    }\r\n\r\n    .login-page .login-figma-kicker {\r\n        text-align: left;\r\n        color: #3194de;\r\n        font-weight: 700;\r\n        letter-spacing: 0.01em;\r\n        font-size: 22px;\r\n        margin-bottom: 40px;\r\n    }\r\n\r\n    .login-page .login-welcome {\r\n        color: #1b80b5;\r\n        font-size: 34px;\r\n        font-weight: 500;\r\n        line-height: 1.1;\r\n        white-space: nowrap;\r\n    }\r\n\r\n    .login-page .login-brand {\r\n        color: #1f1f1f;\r\n        font-size: 56px;\r\n        font-weight: 500;\r\n        line-height: 1.06;\r\n    }\r\n\r\n    .login-page .login-brand span {\r\n        color: #197caf;\r\n        font-weight: 700;\r\n    }\r\n\r\n    .login-page .login-avatar {\r\n        width: 140px;\r\n        margin: 88px auto 24px;\r\n        position: relative;\r\n        height: 128px;\r\n    }\r\n\r\n    .login-page .login-avatar-head {\r\n        width: 50px;\r\n        height: 50px;\r\n        border: 3px solid #1b80b5;\r\n        border-radius: 50%;\r\n        margin: 0 auto;\r\n        background: transparent;\r\n    }\r\n\r\n    .login-page .login-avatar-body {\r\n        width: 95px;\r\n        height: 74px;\r\n        border: 3px solid #1b80b5;\r\n        border-radius: 44px 44px 15px 15px;\r\n        border-top: 0;\r\n        margin: -2px auto 0;\r\n        background: transparent;\r\n    }\r\n\r\n    .login-page .login-title {\r\n        text-align: center;\r\n        font-size: 30px !important;\r\n        font-weight: 700 !important;\r\n        line-height: 1.15;\r\n        color: #1b80b5;\r\n        margin: 0 0 24px !important;\r\n        white-space: nowrap;\r\n    }\r\n\r\n    .login-page .validation-error {\r\n        text-align: center;\r\n        margin-bottom: 8px;\r\n    }\r\n\r\n    .login-page .MuiFormControl-root {\r\n        margin: 0 0 16px !important;\r\n        background: #d7e3ec !important;\r\n        border-radius: 8px;\r\n        overflow: hidden;\r\n    }\r\n\r\n    .login-page .MuiOutlinedInput-root {\r\n        border-radius: 8px;\r\n        background: #d7e3ec !important;\r\n    }\r\n\r\n    .login-page .MuiOutlinedInput-notchedOutline {\r\n        border: 0 !important;\r\n    }\r\n\r\n    .login-page .MuiInputBase-input {\r\n        color: #177eb4 !important;\r\n        font-size: 20px;\r\n        line-height: 1.2;\r\n        padding: 12px 14px;\r\n        font-weight: 500;\r\n    }\r\n\r\n    .login-page form label {\r\n        color: #177eb4 !important;\r\n        font-size: 18px;\r\n        transform: translate(14px, 11px) scale(1);\r\n        font-weight: 500;\r\n    }\r\n\r\n    .login-page .MuiInputLabel-shrink {\r\n        opacity: 0;\r\n    }\r\n\r\n    .login-page .login-actions {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n        gap: 12px;\r\n        margin-top: 12px;\r\n    }\r\n\r\n    .login-page .login-forgot-wrap {\r\n        flex: 1;\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n\r\n    .login-page .forgot-password {\r\n        display: inline-block;\r\n        color: #187eb4;\r\n        font-size: 15px;\r\n        text-decoration: none;\r\n        line-height: 1.2;\r\n        transform: translateY(-5px);\r\n    }\r\n\r\n    .login-page .forgot-password:hover {\r\n        text-decoration: underline;\r\n    }\r\n\r\n    .login-page .buttonFilled {\r\n        margin-top: 0 !important;\r\n        width: 120px !important;\r\n        min-width: 120px;\r\n        min-height: 38px;\r\n        border-radius: 10px !important;\r\n        background-color: #1ea8eb !important;\r\n        box-shadow: none !important;\r\n        text-transform: uppercase;\r\n        font-size: 14px !important;\r\n        font-weight: 700 !important;\r\n        letter-spacing: 0.02em;\r\n        padding: 0 14px !important;\r\n    }\r\n\r\n    .login-page .buttonFilled:hover {\r\n        background-color: #1799d8 !important;\r\n    }\r\n\r\n    .login-page .buttonFilled span {\r\n        color: #fff !important;\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 820px) {\r\n    .login-page .home-hero {\r\n        padding: 28px 16px 34px;\r\n    }\r\n\r\n    .login-page form {\r\n        padding: 28px 18px 40px;\r\n    }\r\n\r\n    .login-page .login-figma-kicker {\r\n        font-size: 16px;\r\n        margin-bottom: 24px;\r\n    }\r\n\r\n    .login-page .login-welcome {\r\n        font-size: 20px;\r\n    }\r\n\r\n    .login-page .login-brand {\r\n        font-size: 30px;\r\n    }\r\n\r\n    .login-page .login-avatar {\r\n        width: 130px;\r\n        height: 120px;\r\n        margin: 74px auto 26px;\r\n    }\r\n\r\n    .login-page .login-avatar-head {\r\n        width: 48px;\r\n        height: 48px;\r\n        border-width: 3px;\r\n    }\r\n\r\n    .login-page .login-avatar-body {\r\n        width: 100px;\r\n        height: 72px;\r\n        border-width: 3px;\r\n        border-radius: 42px 42px 16px 16px;\r\n    }\r\n\r\n    .login-page .login-title {\r\n        font-size: 22px !important;\r\n        margin-bottom: 20px !important;\r\n    }\r\n\r\n    .login-page .login-actions {\r\n        margin-top: 10px;\r\n    }\r\n\r\n    .login-page .MuiInputBase-input {\r\n        font-size: 13px;\r\n        padding: 10px 12px;\r\n    }\r\n\r\n    .login-page form label {\r\n        font-size: 13px;\r\n        transform: translate(12px, 9px) scale(1);\r\n    }\r\n\r\n    .login-page .forgot-password {\r\n        font-size: 12px;\r\n        transform: translateY(-4px);\r\n    }\r\n\r\n    .login-page .buttonFilled {\r\n        min-height: 34px;\r\n        width: 98px !important;\r\n        min-width: 98px;\r\n        font-size: 12px !important;\r\n    }\r\n}\r\n\r\n@media (prefers-color-scheme: dark) and (max-width: 1024px) {\r\n    body.login-route,\r\n    .login-page,\r\n    .login-page .home-hero,\r\n    .login-page .padding-body-2 {\r\n        background: #3a3a3a !important;\r\n    }\r\n\r\n    .login-page .login-paper {\r\n        background: #121212 !important;\r\n    }\r\n\r\n    .login-page .MuiFormControl-root,\r\n    .login-page .MuiOutlinedInput-root,\r\n    .login-page .MuiInputBase-root {\r\n        background: #1a2733 !important;\r\n    }\r\n\r\n    .login-page .MuiInputBase-input,\r\n    .login-page textarea.MuiInputBase-input {\r\n        color: #ffffff !important;\r\n        -webkit-text-fill-color: #ffffff !important;\r\n    }\r\n\r\n    .login-page form label,\r\n    .login-page .MuiFormLabel-root,\r\n    .login-page .MuiInputLabel-root {\r\n        color: #ffffff !important;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
